import type { ItineraryAssignmentDto } from '../../../types/campaign'

type RateFields = Pick<ItineraryAssignmentDto, 'turfMemberCount' | 'turfVisitedCount'>

/** Turf-wide: share of the turf's people visited by anyone, on any day. */
export function turfContactRate(a: RateFields): number {
  return a.turfMemberCount > 0 ? Math.round((a.turfVisitedCount / a.turfMemberCount) * 100) : 0
}

/**
 * One assignment's progress line. doorsKnocked / contactsMade are THIS assignment's actuals (its
 * canvasser, its day -- derived server-side); the trailing % is turf-wide, so it is labelled "turf".
 * Doors are omitted on a worksite turf, which has no home doors (turfDoorCount null).
 */
export function assignmentProgressLabel(
  a: RateFields & Pick<ItineraryAssignmentDto, 'doorsKnocked' | 'contactsMade' | 'turfDoorCount'>,
): string {
  const parts: string[] = []
  if (a.turfDoorCount != null) parts.push(`${a.doorsKnocked} doors`)
  parts.push(`${a.contactsMade} reached`, `turf ${turfContactRate(a)}%`)
  return parts.join(' · ')
}
